import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTenderData } from 'src/models/procurements/Tender/hooks';
import { Expand } from 'src/common';
import { TenderSubCatName, isFieldArray } from 'src/models/procurements/Tender/types';
import { Translations } from 'src/lib/I18nService/types';
import { InfoBox, TenderSubCat } from 'src/shared';
import styles from './index.module.scss';

export const CpvSubCat: FC = () => {
  const { t } = useTranslation();
  const { t: cpvT } = useTranslation(Translations.cpvCodes);
  const { data } = useTenderData();
  const subCat = useMemo(() => data?.generalCat[TenderSubCatName.Cpv], [data]);
  const mainCpvCodes = useMemo(
    () =>
      subCat?.boxes.mainCpvCode && isFieldArray(subCat.boxes.mainCpvCode[0].firstField)
        ? subCat.boxes.mainCpvCode[0].firstField.array
        : undefined,
    [subCat]
  );
  const additionCpvCodes = useMemo(
    () =>
      subCat?.boxes.additionalCpvCode && isFieldArray(subCat.boxes.additionalCpvCode[0].firstField)
        ? subCat.boxes.additionalCpvCode[0].firstField.array
        : undefined,
    [subCat]
  );

  return (
    <>
      {subCat && (
        <TenderSubCat subCat={subCat}>
          <Expand
            visibility={108}
            isListExpandable
            showMoreTitle={t('Common.showAll')}
            isDescription
            buttonClassName={styles.expandButton}
          >
            {mainCpvCodes &&
              mainCpvCodes.length &&
              mainCpvCodes.map(cpvCode => (
                <InfoBox
                  key={cpvCode}
                  className={styles.box}
                  title={
                    <>
                      {cpvCode.split('-')[0]}
                      <span className={styles.tag}>{t('Tenders.mainCode')}</span>
                    </>
                  }
                  value={cpvT(cpvCode.split('-')[0])}
                />
              ))}
            {additionCpvCodes &&
              additionCpvCodes.length &&
              additionCpvCodes.map(cpvCode => (
                <InfoBox
                  key={cpvCode}
                  className={styles.box}
                  title={cpvCode.split('-')[0]}
                  value={cpvT(cpvCode.split('-')[0])}
                />
              ))}
          </Expand>
        </TenderSubCat>
      )}
    </>
  );
};

export default CpvSubCat;
